// extracted by mini-css-extract-plugin
export default {"root":"tweet-info-created-at_root__FYhiL"};